import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { withBrandLayout } from "@/modules/lab/components/BrandLayout";
import { BrandHome } from "@/components/Brand/BrandHome";
const BrandHomePage = ()=>{
    return /*#__PURE__*/ _jsx(BrandHome, {});
};
export var __N_SSP = true;
export default withBrandLayout(BrandHomePage);
